export default __webpack_public_path__ + "static/media/logo-tp-white.7c73d867.svg";